export const splitLoadedPage = <T>(
  loaded: readonly T[],
  lastPageHasMore: boolean | null,
  firstPageSize: number,
): { items: readonly T[]; hasMore: boolean } => {
  const hasMore = lastPageHasMore ?? loaded.length > firstPageSize;
  return { items: hasMore ? loaded.slice(0, -1) : loaded, hasMore };
};
